// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".on[data-v-7602b764]{position:relative}.on[data-v-7602b764]:after{content:\"\";height:7px;width:7px;position:absolute;top:-5px;right:-8px;border-radius:50%;background-color:#f77171}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
